var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"planner"}},[_c('Unassigned'),_vm._v(" "),_c('div',{class:{'wide': !_vm.fullShips},attrs:{"id":"sectors-wrapper"}},[_c('SectorFilter'),_vm._v(" "),_c('div',{attrs:{"id":"theatre-list-wrapper"}},_vm._l((_vm.theatres),function(theatre){return _c('Theatre',{key:theatre,attrs:{"theatreName":theatre}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bf575b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Planner.vue
// module id = null
// module chunks = 